import { render, staticRenderFns } from "./WidgetDebug.vue?vue&type=template&id=0cc37a21&scoped=true&"
import script from "./WidgetDebug.vue?vue&type=script&lang=js&"
export * from "./WidgetDebug.vue?vue&type=script&lang=js&"
import style0 from "./WidgetDebug.vue?vue&type=style&index=0&id=0cc37a21&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc37a21",
  null
  
)

export default component.exports